export default {
  en: {
    activityOverPastYear: 'Activity over past year',
    type: {
      AWS: '@:untranslated.aws.alias',
      Custom: 'custom',
      Cycloid: 'cycloid',
      Monitoring: '@.lower:infra.Monitoring',
    },
    noEventsFound: 'No events found',
    recentActivity: 'Recent activity',
    tryDifferent: 'Try different time ranges and filters.',
    tryDifferentFilters: 'Try different filters.',
    viewAllActivity: 'View all activity',
  },
  es: {
    activityOverPastYear: 'Actividad en el último año',
    type: {
      AWS: '@:untranslated.aws.alias',
      Custom: 'personalizado',
      Cycloid: 'cycloid',
      Monitoring: '@.lower:infra.Monitoring',
    },
    noEventsFound: 'No se encontraron eventos',
    recentActivity: 'Actividad recientes',
    tryDifferent: 'Pruebe diferentes rangos de tiempo y filtros.',
    tryDifferentFilters: 'Prueba diferentes filtros.',
    viewAllActivity: 'Ver toda la actividad',
  },
  fr: {
    activityOverPastYear: `Activité au cours de l'année écoulée`,
    type: {
      AWS: '@:untranslated.aws.alias',
      Custom: 'personnalisé',
      Cycloid: 'cycloid',
      Monitoring: '@.lower:infra.Monitoring',
    },
    noEventsFound: 'Aucun événement trouvé',
    recentActivity: 'Activité récente',
    tryDifferent: `Essayez d'autres plages de temps et filtres.`,
    tryDifferentFilters: 'Essayez différents filtres.',
    viewAllActivity: `Voir toute l'activité`,
  },
}
